import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { SkyLightStateless } from 'react-skylight';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Table, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../Widgets/spinner';
import PurchaseScheduleModal from '../../containers/Purchase/purchaseScheduleModal'
import { Translate, Localize } from 'react-redux-i18n';


class PurchaseScheduleList extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            createOpen: false,

            rows: [],
            selectedRows: null,
            filters: {},
            sortColumn: null,
            sortDirection: null,
        };

        this.handleResize = this.handleResize.bind(this);
        this.openCreate = this.openCreate.bind(this);
        this.closeCreate = this.closeCreate.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchPurchaseSchedules();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if (nextProps.purchaseSchedules && nextProps.purchaseSchedules != this.props.purchaseSchedules) {
          let purchaseSchedules = nextProps.purchaseSchedules;
          purchaseSchedules.map(
            purchaseSchedule => {
              if(purchaseSchedule.RepeatFrequency == "Weekly"){
                switch (purchaseSchedule.RepeatInterval){
                  case 0:
                    purchaseSchedule.RepeatInterval='Monday';
                    break;
                  case 1:
                    purchaseSchedule.RepeatInterval='Tuesday';
                    break;
                  case 2:
                    purchaseSchedule.RepeatInterval='Wednesday';
                    break;
                  case 3:
                    purchaseSchedule.RepeatInterval='Thursday';
                    break;
                  case 4:
                    purchaseSchedule.RepeatInterval='Friday';
                    break;
                  case 5:
                    purchaseSchedule.RepeatInterval='Saturday';
                    break;
                  case 6:
                    purchaseSchedule.RepeatInterval='Sunday';
                    break;

                }
              }
            }
          )
            this.setState({
                rows: purchaseSchedules
            });
        }
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton});
    }

    openCreate() { this.setState({ createOpen: true }); }
    closeCreate() { this.setState({ createOpen: false }); }

    // Set product being selected to be currentProduct and navigate user to the edit page

    setCurrentPurchaseSchedule(e) {
        e.preventDefault();
        const currentPurchaseSchedule = this.state.selectedRows[0];
        this.props.resetCurrentPurchaseSchedule();
        this.props.selectPurchaseSchedule(currentPurchaseSchedule);
        this.context.router.push('/purchaseSchedule/'+currentPurchaseSchedule.PurchaseSchedule_id);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseSchedule();
        this.context.router.push('/purchaseSchedule/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 900) ? 650 : 650;

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'Name',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    width: 100,
                    filterable: true
                },
                {
                    key: 'Description',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true
                },
                {
                    key: 'RepeatFrequency',
                    name: <Translate value="repeat_frequency" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true
                },
                {
                    key: 'RepeatInterval',
                    name: <Translate value="repeat_interval" />,
                    resizable: true,
                    sortable: true,
                    width: 180,
                    filterable: true
                },
               {
                    key: 'StartDate',
                    name: <Translate value="start_date" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true,
                    formatter: DateFormatter
                },
               {
                    key: 'NextExecuteDate',
                    name: <Translate value="next_execute_date" />,
                    resizable: true,
                    sortable: true,
                    width: 160,
                    filterable: true,
                    formatter: DateFormatter
                },
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="PurchaseScheduleList-dataGrid1">
                    <ReactDataGrid
                        rowKey='PurchaseSchedule_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={tableHeight}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const createANewPurchaseSchedule = (<Translate value="create_a_purchase_schedule" />);
        let createDialogStyle = {
            width: '520px',
            marginLeft: '-12%',
        };
        return (
          //---------------
          // Begin HTML
          //---------------
            <ContentWrapper>
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Translate value="purchase_management" />
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active="true">
                    <Translate value="purchase_schedule" />
                  </Breadcrumb.Item>
                </Breadcrumb> {/* End Nav Trail */}

                <Grid id="purchase-schedule-list">
                  <h1><Translate value="purchase_schedule" /></h1>
                  <Panel className="position-relative table-collapse-fix">
                    <ButtonToolbar className="table-buttons">
                        <Button
                            bsStyle="success"
                            type="button"
                            onClick={this.openCreate}
                            disabled={this.checkPermission("add_purchase_schedule")}>
                            <em className="fa fa-plus" /><Translate value="create" />
                        </Button>
                        <Button
                            bsStyle="warning"
                            type="button"
                            onClick={(event) => { this.setCurrentPurchaseSchedule(event) } }
                            disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}>
                            <em className="fa fa-pencil" /><Translate value="edit" />
                        </Button>
                    </ButtonToolbar>
                    {this.renderTable() }
                  </Panel>
                </Grid>
                <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.createOpen} onCloseClicked={() => { this.closeCreate() } } title={createANewPurchaseSchedule}>
                    <PurchaseScheduleModal closeC={this.closeCreate} />
                </SkyLightStateless>
            </ContentWrapper>
            //---------------
            // End HTML
            //---------------
        );
    }
}



export default PurchaseScheduleList;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseScheduleList.jsx